<template>
  <!-- Email verification notifications removed - all users are automatically verified -->
  <div></div>
</template>

<script setup lang="ts">
// Email verification notifications removed since all new users are automatically verified
</script>